module.exports = __webpack_public_path__ + "img/d2500ff.jpg";